export default function WhyChooseUs() {
  const features = [
    {
      icon: (
        <svg
          className="w-8 h-8"
         
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      title: 'Best Price Guarantee',
      description: 'We offer competitive prices and exclusive deals on all our travel packages. Get the best value for your money.',
    },
    {
      icon: (
        <svg
          className="w-8 h-8"
         
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
          />
        </svg>
      ),
      title: 'Safe & Secure',
      description: 'Your safety is our priority. We partner with trusted suppliers and ensure all safety standards are met.',
    },
    {
      icon: (
        <svg
          className="w-8 h-8"
         
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
      ),
      title: '24/7 Support',
      description: 'Our dedicated support team is available round the clock to assist you before, during, and after your trip.',
    },
    {
      icon: (
        <svg
          className="w-8 h-8"

          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
          />
        </svg>
      ),
      title: 'Expert Guides',
      description: 'Travel with experienced local guides who bring destinations to life with their knowledge and passion.',
    },
    {
      icon: (
        <svg
          className="w-8 h-8"
         
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
          />
        </svg>
      ),
      title: 'Customizable Tours',
      description: 'Tailor your travel experience to match your preferences. We offer flexible itineraries to suit your needs.',
    },
    {
      icon: (
        <svg
          className="w-8 h-8"
         
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
          />
        </svg>
      ),
      title: 'Global Destinations',
      description: 'Explore over 200 destinations worldwide. From tropical beaches to mountain peaks, we cover it all.',
    },
  ];

  return (
    <section id="why-choose-us" className="py-16 bg-black-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
            Our Advantages
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold 
          text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 
          mt-2 mb-4">
            Why Choose Compass Connection Agency?
          </h2>
          <p className="text-lg text-white-600 max-w-2xl mx-auto">
            We're committed to providing exceptional travel experiences that exceed your expectations
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl border border-white-200 hover:border-blue-500 hover:shadow-lg transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-16 h-16 bg-blue-950 rounded-lg flex items-center justify-center mb-4 transition-colors duration-300 group-hover:animate-gradient-move group-hover:bg-blue-600">
                <div className="text-blue-600 group-hover:text-white transition-colors duration-300">
                  {feature.icon}
                </div>
              </div>
              {/* Content */}
              <h3 className="text-xl font-bold text-white-900 mb-2 group-hover:text-blue-600 transition-colors">
                {feature.title}
              </h3>
              <p className="text-white-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 pt-12 border-t border-white-200">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 mb-2">15+</div>
              <div className="text-white-600 text-sm">Years of Experience</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 mb-2">200+</div>
              <div className="text-white-600 text-sm">Destinations</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 mb-2">10K+</div>
              <div className="text-white-600 text-sm">Happy Customers</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 mb-2">98%</div>
              <div className="text-white-600 text-sm">Satisfaction Rate</div>
            </div>
          </div>
        </div>

        {/* Testimonial Quote */}
        <div className="mt-16 max-w-3xl mx-auto">
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 sm:p-12 text-center">

            <p className="text-xl text-gray-700 mb-6 italic">
              "Compass Connection Agency has made our dream vacation a reality. From booking to the actual trip, everything was seamless and well-organized. Highly recommended!"
            </p>
            <div className="flex items-center justify-center space-x-1 mb-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <svg
                  key={star}
                  fill="currentColor"
                  className="w-5 h-5 text-yellow-400"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
            <p className="font-semibold text-white-900">Sarah Johnson</p>
            <p className="text-sm text-white-600">Verified Traveler</p>
          </div>
        </div>
      </div>
    </section>
  );
}